<h1 class="text-center pt-0">Tidy Ranking</h1>

<p-message severity="warn" class="mb-4" *ngIf="hasInviteCode">
  <h2>Invite Code</h2>
  Please either create an account or log into your account to accept the invite code.
</p-message>


<form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
  <div class="mt-4">
    <label class="block text-sm font-bold mb-2">Email Address</label>
    <input pInputText id="email" formControlName="email" autocomplete="off" class="w-full" maxlength="250" type="email"
      placeholder="your@email.com" />

    <div class="input-validation" *ngIf="loginForm.controls['email'].invalid && loginForm.controls['email'].touched">
      <div *ngIf="loginForm.controls['email'].hasError('required')">
        What is your email
      </div>
      <div *ngIf="loginForm.controls['email'].hasError('email')">
        That's not an email
      </div>
    </div>
  </div>

  <div class="mt-4">
    <div class="flex justify-between">
      <label class="block text-sm font-bold mb-2">Password</label>
      <a routerLink="/forgot" class="text-xs text-gray-500" tabindex="-1">Forget Password?</a>
    </div>

    <p-iconfield>
      <input pInputText id="password" formControlName="password" autocomplete="off" class="w-full" maxlength="250"
        [type]="showPassword ? 'text' : 'password'" />
      <p-inputicon [styleClass]="showPassword ? 'bi-eye-fill' : 'bi-eye-slash-fill'" (click)="showPassword = !showPassword" />
    </p-iconfield>

    <div class="input-validation" *ngIf="loginForm.controls['password'].invalid && loginForm.controls['password'].touched">
      <div *ngIf="loginForm.controls['password'].hasError('required')">
        Your password is required
      </div>
    </div>

  </div>

  <div class="mt-8">
    <p-button [label]="submitting ? 'Signing in...' : 'Sign in'" type="submit" icon="bi bi-box-arrow-in-right" severity="primary" fluid="true"
      [disabled]="submitting"></p-button>
  </div>

  <!-- <div class="mt-6 text-center">
    <a routerLink="/signup" class="text-gray-500">Don't have an account? Sign up</a>
  </div> -->
</form>